import { render, staticRenderFns } from "./viewSwiper.vue?vue&type=template&id=2c4ec732&scoped=true&"
import script from "./viewSwiper.vue?vue&type=script&lang=js&"
export * from "./viewSwiper.vue?vue&type=script&lang=js&"
import style0 from "./viewSwiper.vue?vue&type=style&index=0&id=2c4ec732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4ec732",
  null
  
)

export default component.exports